import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import { FaHeart, FaMapMarkerAlt, FaArrowRight } from "react-icons/fa";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { useNavigate } from "react-router-dom";

export default function Wishlist() {
    const [wishlist, setWishlist] = useState([]);
    const navigate = useNavigate();

    // REMOVE FROM WISHLIST
    const removeFromWishlist = (id) => {
        const updated = wishlist.filter((item) => item.id !== id);

        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    // LOAD WISHLIST
    useEffect(() => {
        const stored =
            JSON.parse(localStorage.getItem("wishlist")) || [];

        setWishlist(stored);
    }, []);

    return (
        <div className="min-h-screen overflow-hidden bg-[#F7F5EF]">

            {/* HERO */}
            <Hero
                heightClass="h-[180px] sm:h-[220px] md:h-[240px] lg:h-[250px]"
                title="Wishlist"
                backgroundImage={heroImg}
                contentClass=""
            />

            {/* WISHLIST SECTION */}
            <section className="w-full bg-[#F7F5EF] py-12 sm:py-14 lg:py-16">

                <div className="mx-auto  max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8">

                    {/* SECTION HEADER */}
                    <div className="mb-8 sm:mb-10">

                        <div className="flex items-center gap-3">
                            <span className="h-[2px] w-9 rounded-full bg-[#FF5A1F]" />

                            <span className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#0B6E8E]">
                                Your Favorite Stays
                            </span>
                        </div>

                        <div className="mt-4 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">

                            <div>
                                <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-[#173F4A] sm:text-4xl lg:text-[42px]">
                                    My Wishlist
                                    <span className="ml-2 text-[#FF5A1F]">.</span>
                                </h2>

                                <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">
                                    Keep the hotels you love close at hand
                                    and return whenever you're ready to
                                    plan your perfect Dubai stay.
                                </p>
                            </div>

                            {/* WISHLIST COUNT */}
                            {wishlist.length > 0 && (
                                <div className="inline-flex w-fit items-center gap-2.5 rounded-xl border border-[#0B6E8E]/15 bg-white px-4 py-3 text-xs font-bold text-[#173F4A] shadow-sm">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#FF5A1F]/10">
                                        <FaHeart className="text-sm text-[#FF5A1F]" />
                                    </span>

                                    <span>
                                        {wishlist.length}{" "}
                                        {wishlist.length === 1
                                            ? "Saved Hotel"
                                            : "Saved Hotels"}
                                    </span>
                                </div>
                            )}

                        </div>
                    </div>

                    {/* EMPTY WISHLIST */}
                    {wishlist.length === 0 ? (

                        <div className="relative flex min-h-[380px] flex-col items-center justify-center overflow-hidden rounded-3xl border border-[#0B6E8E]/10 bg-white px-6 py-16 text-center shadow-[0_12px_40px_rgba(11,110,142,0.05)] sm:min-h-[420px] sm:py-20">

                            {/* DECORATIVE ACCENTS */}
                            <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#F7B928]/10 blur-2xl" />
                            <div className="absolute -bottom-20 -left-16 h-52 w-52 rounded-full bg-[#0B6E8E]/5 blur-2xl" />

                            <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl border border-[#FF5A1F]/15 bg-[#FF5A1F]/10 text-[#FF5A1F] transition-transform duration-300 hover:scale-105">
                                <FaHeart className="text-3xl" />
                            </div>

                            <h3 className="relative mt-6 text-2xl font-extrabold text-[#173F4A] sm:text-3xl">
                                Your Wishlist is Empty
                            </h3>

                            <p className="relative mt-3 max-w-md text-sm leading-7 text-slate-500 sm:text-base">
                                Save your favorite hotels while exploring
                                Dubai and they'll appear here for easy
                                access whenever you're ready to book.
                            </p>

                            {/* EXPLORE BUTTON */}
                            <button
                                type="button"
                                onClick={() => navigate("/hotels")}
                                className="group relative mt-7 inline-flex items-center justify-center gap-3 rounded-xl bg-[#FF5A1F] px-6 py-3.5 text-sm font-bold text-white shadow-[0_8px_20px_rgba(255,90,31,0.20)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#E94B14] hover:shadow-[0_12px_26px_rgba(255,90,31,0.28)]"
                            >
                                Explore Hotels

                                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-white/20 transition-transform duration-300 group-hover:translate-x-1">
                                    <FaArrowRight className="text-[11px]" />
                                </span>
                            </button>

                        </div>

                    ) : (

                        /* HOTEL GRID */
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-7">

                            {wishlist.map((hotel) => (

                                <div
                                    key={hotel.id}
                                    onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                    className="group cursor-pointer overflow-hidden rounded-2xl border border-[#0B6E8E]/10 bg-white shadow-[0_6px_24px_rgba(23,63,74,0.05)] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#0B6E8E]/25 hover:shadow-[0_18px_40px_rgba(23,63,74,0.12)]"
                                >

                                    {/* IMAGE */}
                                    <div className="relative h-[240px] w-full overflow-hidden sm:h-[250px]">

                                        <img
                                            src={`https://cheapdubaihotels.com/uploads/hotels/${hotel.image}`}
                                            alt={hotel.name}
                                            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        />

                                        {/* IMAGE OVERLAY */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#002B45]/75 via-[#002B45]/10 to-transparent" />

                                        {/* LOCATION BADGE */}
                                        <div className="absolute left-4 top-4 z-10">
                                            <span className="inline-flex max-w-[220px] items-center gap-2 rounded-lg border border-white/60 bg-white/95 px-3 py-2 text-xs font-semibold text-[#173F4A] shadow-sm backdrop-blur-md">
                                                <FaMapMarkerAlt className="shrink-0 text-[#FF5A1F]" />
                                                <span className="truncate">
                                                    {hotel.location || "Dubai, UAE"}
                                                </span>
                                            </span>
                                        </div>

                                        {/* REMOVE BUTTON */}
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                removeFromWishlist(hotel.id);
                                            }}
                                            className="absolute right-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-xl border border-white/60 bg-white/95 text-[#FF5A1F] shadow-md backdrop-blur-md transition-all duration-300 hover:scale-110 hover:bg-[#FF5A1F] hover:text-white"
                                            aria-label="Remove from wishlist"
                                            title="Remove from wishlist"
                                        >
                                            <FaHeart className="text-sm" />
                                        </button>

                                        {/* RATING */}
                                        <div className="absolute bottom-4 left-4 z-10">
                                            <div className="flex items-center gap-2 rounded-lg border border-white/30 bg-white/95 px-3 py-2 shadow-md backdrop-blur-md">
                                                <span className="text-base text-[#F7B928]">★</span>

                                                <span className="text-sm font-extrabold text-[#173F4A]">
                                                    {hotel.rating || "4.5"}
                                                </span>

                                                <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
                                                    Excellent
                                                </span>
                                            </div>
                                        </div>

                                        {/* PRICE */}
                                        <div className="absolute bottom-4 right-4 z-10 rounded-xl bg-[#002B45] px-3.5 py-2.5 text-white shadow-lg sm:px-4">

                                            <p className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#F7B928]">
                                                From
                                            </p>

                                            <p className="mt-0.5 text-sm font-extrabold">
                                                AED{" "}
                                                {Math.round(
                                                    hotel.price_per_night
                                                )}

                                                <span className="ml-1 text-[10px] font-medium text-white/70">
                                                    / night
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    {/* CARD CONTENT */}
                                    <div className="p-5 sm:p-6">

                                        {/* HOTEL NAME */}
                                        <h3 className="line-clamp-1 text-xl font-extrabold tracking-tight text-[#173F4A] transition-colors duration-300 group-hover:text-[#0B6E8E]">
                                            {hotel.name}
                                        </h3>

                                        {/* LOCATION */}
                                        <div className="mt-2 flex items-center gap-2 text-slate-500">
                                            <FaMapMarkerAlt className="shrink-0 text-xs text-[#FF5A1F]" />

                                            <span className="text-sm">
                                                {hotel.location || "Dubai, UAE"}
                                            </span>
                                        </div>

                                        {/* DIVIDER */}
                                        <div className="my-5 h-px bg-slate-100" />

                                        {/* DESCRIPTION */}
                                        <p className="min-h-[48px] line-clamp-2 text-sm leading-6 text-slate-600">
                                            {hotel.short_description?.replace(
                                                /<[^>]*>/g,
                                                ""
                                            )}
                                        </p>

                                        {/* AMENITIES */}
                                        <div className="mt-5 flex flex-wrap gap-2">

                                            <span className="rounded-lg border border-[#0B6E8E]/10 bg-[#0B6E8E]/5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide text-[#0B6E8E]">
                                                🏊 Pool
                                            </span>

                                            <span className="rounded-lg border border-[#0B6E8E]/10 bg-[#0B6E8E]/5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide text-[#0B6E8E]">
                                                📶 WiFi
                                            </span>

                                            <span className="rounded-lg border border-[#0B6E8E]/10 bg-[#0B6E8E]/5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide text-[#0B6E8E]">
                                                🍽 Restaurant
                                            </span>

                                        </div>

                                        {/* VIEW HOTEL BUTTON */}
                                        <div className="mt-6">

                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/hotels/${hotel.slug}`);
                                                }}
                                                className="group/button flex w-full items-center justify-center gap-3 rounded-xl bg-[#0B6E8E] px-5 py-3 text-sm font-bold text-white transition-all duration-300 hover:bg-[#08576F] hover:shadow-[0_8px_20px_rgba(11,110,142,0.20)]"
                                            >
                                                View Hotel Details

                                                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#F7B928] text-[#002B45] transition-transform duration-300 group-hover/button:translate-x-1">
                                                    <FaArrowRight className="text-[10px]" />
                                                </span>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            </section>

            {/* FOOTER */}
        </div>
    );
}
